const RETRYABLE_STATUS_CODES = new Set([408, 429, 500, 502, 503, 504]);

function wait(ms: number) {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

function retryDelay(attempt: number) {
  return 350 * 2 ** attempt;
}

function isNetworkFetchError(error: unknown) {
  if (!(error instanceof Error)) return false;
  const message = error.message.toLowerCase();
  return (
    error.name === 'TypeError' ||
    error.name === 'NetworkError' ||
    message.includes('failed to fetch') ||
    message.includes('networkerror') ||
    message.includes('network request failed')
  );
}

export function friendlyRequestError(error: unknown, fallback: string) {
  if (isNetworkFetchError(error)) {
    return 'The request did not receive a response. Please retry; if it keeps happening, the connection or browser may be blocking the request.';
  }

  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

export async function fetchWithRetry(input: RequestInfo | URL, init?: RequestInit, opts?: { retries?: number }) {
  const retries = opts?.retries ?? 2;
  let lastError: unknown = null;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const response = await fetch(input, init);
      if (!RETRYABLE_STATUS_CODES.has(response.status) || attempt === retries) return response;
      lastError = new Error(`Request failed (${response.status})`);
    } catch (error) {
      lastError = error;
      if (!isNetworkFetchError(error) || attempt === retries) throw error;
    }

    await wait(retryDelay(attempt));
  }

  throw lastError instanceof Error ? lastError : new Error('Request failed');
}
